import React from "react";
import set from "@rill/set";
import defaults from "lodash/defaults";

import SortCategoriesModal from "../../../parts/modals/sort-categories";
import ManageCategoriesModal from "../../../parts/modals/manage-categories";
import AddTutorialModal from "../../../parts/modals/add-tutorial-modal";
import TutorialCategory from "./tutorial-category";

const tutorialCategoryController = (app) => {
  app
    .use(set("heading", ["Admin", "Tutorial Categories"]))
    .get("/tutorials", async ({ load, locals, res, req }) => {
      defaults(req.query, {
        product: "general",
        category: "All",
        selectedCategoryIndex: null,
      });

      const { query = {} } = req;
      const { modal = {} } = query;

      await load("tutorialCategories", query.product);
      await load("tutorialVideos", {
        category: "All",
        product: query.product,
      });

      const tutorialCategories = locals.tutorialCategories || [];

      const categoryNames = tutorialCategories.map(({ name }) => {
        return name;
      });

      const getTutorial = (selectedTutorial) => {
        if (!selectedTutorial) return null;
        const tutorial = (locals.tutorialVideos || []).find((tutorial) => {
          return tutorial._id === selectedTutorial;
        });
        return tutorial;
      };

      locals.modal = {
        "manage-categories": (
          <ManageCategoriesModal
            entity="Topics"
            programs={locals.tutorialVideos || []}
            category={query.category}
            selectedCategoryIndex={query.selectedCategoryIndex}
            selectedCategoryId={query.selectedCategoryId}
            product={query.product}
            newCategory={query.newCategory || false}
            onSave={() => {}}
          />
        ),
        "sort-categories": (
          <SortCategoriesModal
            categories={tutorialCategories}
            isCategoryObject
            onSave={() => {}}
          />
        ),
        "add-tutorial": (
          <AddTutorialModal
            tutorialCategories={tutorialCategories}
            product={query.product}
            selectedTutorial={getTutorial(query.selectedTutorial)}
          />
        ),
      }[modal.type];

      res.body = (
        <TutorialCategory
          allCategories={tutorialCategories}
          allVideos={locals.tutorialVideos || []}
          categoryNames={categoryNames}
        />
      );
    });
};

export default tutorialCategoryController;
